export default {
  get: function(k) {
    return null;
    // try {
    //   return JSON.parse(window.localStorage.getItem(k));
    // }
    // catch(e) {
    //   return null;
    // }
  },
  set: function(k, v) {
    return null;
    // window.localStorage.setItem(k, JSON.stringify(v));
  }
};



// WEBPACK FOOTER //
// ./src/libs/storage.js